export function SubmitButton(props) {
  const { onSubmit = () => {}, children, className = "", disabled = false } = props;
  const content = children || "Submit";

  return (
    <button className={`btn btn-primary ${className}`} onClick={onSubmit} disabled={disabled}>
      {content}
    </button>
  );
}

export default SubmitButton;
